(function () {
    'use strict';

    angular.module("imApp").factory("shiftDayTimeService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 535,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 538,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 539,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
